import { UpdateElectronStatus } from '~/types/enum';
import { invokeChannel, onChannel, sendChannel } from '../constants';
import { isWeb } from '../helper/device';
import { ProgressInfo } from 'electron-updater';

const webHandlers = {
  //   reloadMyCDCase() {
  //   },
  updateHandle: () => {},
  getUpdateMessage: () => {},
  isDownload: () => {},
  updateDownloadProgress: () => {},
  isInstall: () => {},
};
const desktopHandlers = {
  //   reloadMyCDCase(callback: (event: any) => void) {
  //     // @ts-ignore
  //     window.api.recieve('reloadMyCDCase', ([event]) => {
  //       callback(event)
  //     })
  //   },
  updateHandle: () => {
    window.api.invoke(invokeChannel.updateHandle);
  },
  getUpdateMessage: (
    callback: (event: { message: string; state: UpdateElectronStatus }) => void,
  ) => {
    window.api.on(onChannel.updateMsg, ([event]) => {
      callback(event as { message: string; state: UpdateElectronStatus });
    });
  },
  isDownload: () => {
    window.api.send(sendChannel.beginDownload);
  },
  updateDownloadProgress: (callback: (event: ProgressInfo) => void) => {
    window.api.on(onChannel.downloadProgress, ([event]) => {
      callback(event as ProgressInfo);
    });
  },
  isInstall: () => {
    window.api.send(sendChannel.beginInstall);
  },
};

export const useUpdate = () => {
  const {
    updateHandle,
    getUpdateMessage,
    isDownload,
    updateDownloadProgress,
    isInstall,
  } = isWeb ? webHandlers : desktopHandlers;

  return {
    updateHandle,
    getUpdateMessage,
    isDownload,
    updateDownloadProgress,
    isInstall,
  };
};
